// Copyright Abridged, Inc. 2023,2024. All Rights Reserved.
// Node module: @collabland/sdk
// This file is licensed under the MIT License.
// License text available at https://opensource.org/license/mit/

import {model, property} from '@loopback/repository';

/**
 * The model class is generated from OpenAPI schema - TelefrensCopyTradingSubmitRequest
 * TelefrensCopyTradingSubmitRequest
 */
@model({name: 'TelefrensCopyTradingSubmitRequest'})
export class TelefrensCopyTradingSubmitRequest {
  constructor(data?: Partial<TelefrensCopyTradingSubmitRequest>) {
    if (data != null && typeof data === 'object') {
      Object.assign(this, data);
    }
  }

  /**
   * The copy trading referrer Telegram user Id
   */
  @property({
    jsonSchema: {
      type: 'string',
      description: 'The copy trading referrer Telegram user Id',
    },
  })
  referrerUserId?: string;

  /**
   * Copy trading slug
   */
  @property({
    jsonSchema: {
      type: 'string',
      description: 'Copy trading slug',
    },
  })
  slug?: string;

  /**
   * Contract address of the token to sell
   */
  @property({
    jsonSchema: {
      type: 'string',
      description: 'Contract address of the token to sell',
    },
  })
  fromTokenAddress?: string;

  /**
   * Purchase amount in big number string
   */
  @property({
    jsonSchema: {
      type: 'string',
      description: 'Purchase amount in big number string',
    },
  })
  fromTokenAmount?: string;

  /**
   * Token symbol of the token to sell
   */
  @property({
    jsonSchema: {
      type: 'string',
      description: 'Token symbol of the token to sell',
    },
  })
  fromTokenSymbol?: string;

  /**
   * Token symbol of the token o purchase
   */
  @property({
    jsonSchema: {
      type: 'string',
      description: 'Token symbol of the token o purchase',
    },
  })
  toTokenSymbol?: string;

  /**
   * Contract address of the token to purchase
   */
  @property({
    jsonSchema: {
      type: 'string',
      description: 'Contract address of the token to purchase',
    },
  })
  toTokenAddress?: string;

  /**
   * Quote calldata
   */
  @property({
    jsonSchema: {
      type: 'string',
      description: 'Quote calldata',
    },
  })
  callData?: string;

  /**
   * Swap contract address
   */
  @property({
    jsonSchema: {
      type: 'string',
      description: 'Swap contract address',
    },
  })
  toContractAddress?: string;

  /**
   * Quote value
   */
  @property({
    jsonSchema: {
      type: 'string',
      description: 'Quote value',
    },
  })
  value?: string;
}

export interface TelefrensCopyTradingSubmitRequestRelations {
  // describe navigational properties here
}

export type TelefrensCopyTradingSubmitRequestWithRelations =
  TelefrensCopyTradingSubmitRequest &
    TelefrensCopyTradingSubmitRequestRelations;
